import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { AiService } from '../../../service/ai.service';
import { FormBuilder, } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ProjectknowledgeComponent } from '../settings/projectknowledge/projectknowledge.component';
import { RestartChatComponent } from './restart-chat/restart-chat.component';
import { UserdataService } from '../../../service/userdata.service';

@Component({
  selector: 'rr-ai-chat',
  standalone: false,

  templateUrl: './ai-chat.component.html',
  styleUrl: './ai-chat.component.scss'
})
export class AiChatComponent implements AfterViewInit {
  @ViewChild('chatContent') chatContent!: ElementRef;
  private subscriptions: Subscription = new Subscription();

  showAiChat: boolean = false;
  hideLoading: boolean = false;
  recognitionAllowed: boolean = false;
  runningRecignition: boolean = false;
  newPrompts: boolean = false;
  activeRecognition: any;
  SpeechRecognition: any;
  modelId: string = ""
  activeHint: boolean = false;
  showHintAnimation: boolean = false;
  disableInput: boolean = false;

  chatInput: any = this.fb.control('')

  aiChat: any[] = [];
  aiChatHint: any[] = [];

  constructor(
    private fb: FormBuilder,
    private aiService: AiService,
    private dialog: MatDialog,
    private userService: UserdataService,
  ) {

  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit(): void {
    this.SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (this.SpeechRecognition) {
      this.recognitionAllowed = true;
    }
    this.subscriptions.add(
      this.aiService.showAiChat.subscribe((data: boolean) => {
        this.showAiChat = data;
        this.scrollToBottom();
      })
    )
    this.subscriptions.add(
      this.aiService.aiChat.subscribe((data: any[]) => {
        this.aiChat = data;
        this.scrollToBottom();
      })
    )
    this.subscriptions.add(
      this.aiService.activeHint.subscribe((data: boolean) => {
        this.activeHint = data;
      })
    )
    this.subscriptions.add(
      this.aiService.showHintAnimation.subscribe((data: boolean) => {
        this.showHintAnimation = data;
      })
    )
    this.subscriptions.add(
      this.aiService.showHintAnimationChat.subscribe((data: any[]) => {
        this.aiChatHint = data;
      })
    )
    this.subscriptions.add(
      this.aiService.modelId.subscribe((data: string) => {
        this.modelId = data;
      })
    )
    // this.uploadFileToRag()
  }
  startSpeechRecognition() {
    this.activeRecognition = new this.SpeechRecognition();
    const userLang = this.userService.data.getValue()?.lang || 'en';
    this.activeRecognition.lang = userLang === 'de' ? 'de-DE' : 'en-US';
    this.activeRecognition.continuous = true;
    this.activeRecognition.interimResults = false;
    this.runningRecignition = true;

    this.activeRecognition.onstart = () => {
      console.log('Spracherkennung gestartet...');
    };

    this.activeRecognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      this.chatInput.setValue(transcript);
    };

    this.activeRecognition.onerror = (event: any) => {
      alert('Fehler bei der Spracherkennung:' + event.error);
      console.error('Fehler bei der Spracherkennung:', event.error);
    };

    this.activeRecognition.onend = () => {
      console.log('Spracherkennung beendet.');
    };

    this.activeRecognition.start();
  }
  stopSpeechRecognition() {
    this.runningRecignition = false;
    this.activeRecognition.stop();
  }
  async addSuggestionToFormular(suggestion: any, context_id: string | undefined) {
    console.log('Suggestion added to form:', suggestion);

    this.aiService.contentForInput.next({ "id": this.modelId, "text": suggestion.text, context_id });
  }
  async selectSuggestion(suggestion: any) {
    console.log('Suggestion selected:', suggestion);
    this.hideLoading = true;
    await this.aiService.defaultAiService(this.modelId, suggestion.text)
    this.hideLoading = false;
  }
  async uploadFileToRag() {
    let dl = await this.dialog.open(ProjectknowledgeComponent, {
      panelClass: ''
    })
    // alert('File upload to RAG is not yet implemented.');
  }
  close() {
    this.aiService.showAiChat.next(false);
  }
  closeAnimationHint() {
    this.aiService.showHintAnimation.next(false);
  }
  async send(event: KeyboardEvent | Event | null) {

    // Bei Shift+Enter: Zeilenumbruch erlauben und nicht senden
    if (event && 'shiftKey' in event && (event as KeyboardEvent).shiftKey) {
      return;
    }
    this.chatInput.value = this.chatInput.value.replace(/\n$/, '');

    if (!this.chatInput.value.trim()) {
      console.warn('Message is empty or only contains whitespace.');
      return;
    }

    let inputValue = this.chatInput.value;
    this.chatInput.setValue('');
    this.hideLoading = true;
    this.disableInput = true;
    this.chatInput.disable();
    await this.aiService.defaultAiService(this.modelId, inputValue);
    this.chatInput.enable();
    this.disableInput = false;
    this.hideLoading = false;
  }
  openChat() {
    this.aiService.agentId.next("flying_jhonny");
    if (this.aiService.showAiChat.getValue() === false) {
      this.activeHint = false;
      this.aiService.showHintAnimation.next(false);
      this.aiService.showAiChat.next(true);
    } else {
      this.aiService.showAiChat.next(false);
    }
  }
  resetChat() {
    // delete threadId, aiChat = [], supportMe (Pproblem)
    const dialogRef = this.dialog.open(RestartChatComponent, {
      panelClass: 'small-dialog',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.aiService.threadId = undefined;
        this.aiService.aiChat.next([]);
        this.chatInput.reset();
        this.send(null);
      }
    })
  }
  asnwerForMe(sugesstiionArray: any[], contextId: string | undefined) {
    // Random Number between 0 & 3
    let randomNumber = Math.floor(Math.random() * 4);
    this.addSuggestionToFormular(sugesstiionArray[randomNumber], contextId);
  }
  async refreshSuggestions() {
    this.hideLoading = true;
    await this.aiService.defaultAiService(this.modelId, 'be creative and generate new suggestions that are totally different from the recent ones but still match the topic.', true);
    this.hideLoading = false;
  }
  scrollToBottom(): void {
    try {
      setTimeout(() => {
        if (this.chatContent?.nativeElement)
          this.chatContent.nativeElement.scrollTop = this.chatContent.nativeElement.scrollHeight;
      }, 100);
    } catch (err) {
      // console.log(err);
    }
  }
}
